import { frontendURL } from 'dashboard/helper/URLHelper';
import {
  PLANNING_EVENT_CREATE_PERMISSION,
  PLANNING_EVENT_MANAGE_PERMISSION,
} from 'dashboard/constants/permissions';

const PLANNING_VIEW_PERMISSIONS = [
  'administrator',
  'agent',
  'custom_role',
  PLANNING_EVENT_CREATE_PERMISSION,
  PLANNING_EVENT_MANAGE_PERMISSION,
];

const PlanningRoutes = {
  path: frontendURL('accounts/:accountId/planning'),
  name: 'planning',
  meta: {
    permissions: PLANNING_VIEW_PERMISSIONS,
  },
  component: () => import('./Index.vue'),
  children: [
    {
      path: 'views/:viewId',
      name: 'planning_calendar_view',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./Calendar.vue'),
    },
    {
      path: 'find-slots',
      name: 'planning_find_slots',
      meta: {
        permissions: ['administrator'],
      },
      component: () => import('./FindSlots.vue'),
    },
    {
      path: 'events/views/:viewId',
      name: 'planning_events_view',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./events/Index.vue'),
    },
    {
      path: 'events/board/views/:viewId',
      name: 'planning_events_board_view',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./events/Kanban.vue'),
    },
    {
      path: 'events',
      name: 'planning_events',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./events/Index.vue'),
    },
    {
      path: 'events/status/:stage',
      name: 'planning_events_stage',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./events/Index.vue'),
    },
    {
      path: 'events/board',
      name: 'planning_events_board',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./events/Kanban.vue'),
    },
    {
      path: 'events/new',
      name: 'planning_events_new',
      meta: {
        permissions: [
          'administrator',
          'agent',
          'custom_role',
          PLANNING_EVENT_MANAGE_PERMISSION,
          PLANNING_EVENT_CREATE_PERMISSION,
        ],
      },
      component: () => import('./events/New.vue'),
    },
    {
      path: 'events/:eventId',
      name: 'planning_events_show',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./events/Show.vue'),
    },
    {
      path: 'events/:eventId/promote-inquiry',
      name: 'planning_events_promote_inquiry',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./events/PromoteInquiry.vue'),
    },
    {
      path: 'events/:eventId/edit',
      name: 'planning_events_edit',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./events/Edit.vue'),
    },
    {
      path: 'events/:eventId/floorplan/:floorplanId',
      name: 'planning_event_floorplan',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./events/EventFloorplanEditor.vue'),
    },
    {
      path: 'displays',
      name: 'planning_displays',
      meta: {
        permissions: ['administrator'],
      },
      component: () => import('./displays/Index.vue'),
    },
    {
      path: 'lost-and-found',
      component: () => import('./lostAndFound/LostAndFoundLayout.vue'),
      redirect: { name: 'planning_lost_and_found_objects' },
      children: [
        {
          path: 'objects',
          name: 'planning_lost_and_found_objects',
          meta: {
            permissions: PLANNING_VIEW_PERMISSIONS,
          },
          component: () => import('./lostObjects/Index.vue'),
        },
        {
          path: 'objects/:lostObjectId',
          name: 'planning_lost_and_found_objects_show',
          meta: {
            permissions: PLANNING_VIEW_PERMISSIONS,
          },
          component: () => import('./lostObjects/Show.vue'),
        },
        {
          path: 'reports',
          name: 'planning_lost_and_found_reports',
          meta: {
            permissions: PLANNING_VIEW_PERMISSIONS,
          },
          component: () => import('./lostReports/Index.vue'),
        },
        {
          path: 'reports/:lostReportId',
          name: 'planning_lost_and_found_reports_show',
          meta: {
            permissions: PLANNING_VIEW_PERMISSIONS,
          },
          component: () => import('./lostReports/Show.vue'),
        },
      ],
    },
    {
      path: 'lost-objects',
      redirect: { name: 'planning_lost_and_found_objects' },
    },
    {
      path: 'lost-objects/:lostObjectId',
      redirect: to => ({
        name: 'planning_lost_and_found_objects_show',
        params: { lostObjectId: to.params.lostObjectId },
      }),
    },
    {
      path: ':date?',
      name: 'planning_calendar',
      meta: {
        permissions: PLANNING_VIEW_PERMISSIONS,
      },
      component: () => import('./Calendar.vue'),
    },
  ],
};

export default PlanningRoutes;
